import { useEffect } from 'react';
import { AccountFeature, useAccountFeature } from 'hooks/use-account-feature';
import { useLocalStorage } from 'hooks/use-local-storage';
import { APP_SHELL_MODE_STORAGE_KEY, DEFAULT_APP_SHELL_MODE } from 'utils/app-shell-mode';
import { isTauriApp } from 'utils/is-tauri';
/**
 * Persisted Rocketlane ↔ Nitro Claw shell preference (web).
 * Tauri presents the Nitro Claw shell when `AccountFeature.NitroClaw` is on.
 * When the account feature is off, web preference is reset to Rocketlane.
 */ export const useAppShellMode = ()=>{
    const [isNitroClawEnabled] = useAccountFeature(AccountFeature.NitroClaw);
    const [mode, setMode] = useLocalStorage(APP_SHELL_MODE_STORAGE_KEY, DEFAULT_APP_SHELL_MODE);
    useEffect(()=>{
        if (!isTauriApp() && !isNitroClawEnabled && mode === 'nitro-claw') {
            setMode(DEFAULT_APP_SHELL_MODE);
        }
    }, [
        isNitroClawEnabled,
        mode,
        setMode
    ]);
    const isNitroClawShellActive = isNitroClawEnabled && (isTauriApp() || mode === 'nitro-claw');
    return {
        mode,
        setMode,
        isNitroClawShellActive,
        isNitroClawEnabled
    };
};
